import { render, staticRenderFns } from "./rwstep1.vue?vue&type=template&id=2596c0c7&scoped=true&"
import script from "./rwstep1.vue?vue&type=script&lang=js&"
export * from "./rwstep1.vue?vue&type=script&lang=js&"
import style0 from "./rwstep1.vue?vue&type=style&index=0&id=2596c0c7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596c0c7",
  null
  
)

export default component.exports